<template>
  <div class="modal-wrap">
    <el-dialog
      title="新增产品"
      :visible.sync="dialogVisible"
      width="900px"
      @closed="modalClosed"
      @open="initSelect"
      :close-on-click-modal="false"
    >
      <div class="form-wrap" ref="formWrapRef">
        <el-form label-width="110px" :model="formData" :rules="rules" ref="tableRef">
          <el-form-item label="产品名称：" prop="productId">
            <el-select class="select-item" v-model="formData.productId" placeholder="产品" filterable>
              <el-option v-for="item in productList" :key="item.id" :label="item.appName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型：" prop="type">
            <el-select class="select-item" v-model="formData.type" placeholder="类型">
              <el-option label="投放测试" value="投放测试"></el-option>
              <el-option label="增加量级" value="增加量级"></el-option>
              <el-option label="减少量级" value="减少量级"></el-option>
              <el-option label="维持投放" value="维持投放"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品投放状态：" prop="productStatus">
            <el-select class="select-item" v-model="formData.productStatus" placeholder="请选择">
              <el-option label="稳定投放" value="稳定投放"> </el-option>
              <el-option label="已暂停" value="已暂停"> </el-option>
              <el-option label="测试中" value="测试中"> </el-option>
              <el-option label="上线待测试" value="上线待测试"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="投放负责人：" prop="principalName">
            <el-select class="select-item" v-model="formData.principalName" placeholder="请选择" filterable allow-create multiple>
              <el-option v-for="item in principalNameList" :key="item.id" :label="item.principalName" :value="item.principalName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市场：" prop="market">
            <el-select class="select-item" v-model="formData.market" placeholder="请选择">
              <el-option label="谷歌" value="谷歌"> </el-option>
              <el-option label="IOS" value="IOS"> </el-option>
              <el-option label="华为海外" value="华为海外"> </el-option>
              <el-option label="亚马逊" value="亚马逊"> </el-option>
              <el-option label="传音海外" value="传音海外"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品分级：" prop="productGrade">
            <el-select class="select-item" v-model="formData.productGrade" placeholder="请选择">
              <el-option label="A1" value="A1"> </el-option>
              <el-option label="A2" value="A2"> </el-option>
              <el-option label="B1" value="B1"> </el-option>
              <el-option label="B2" value="B2"> </el-option>
              <el-option label="空" value="空"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市场本地化：" prop="marketLocal">
            <el-input
              class="input-area small-area"
              type="textarea"
              :rows="3"
              placeholder="请输入"
              v-model="formData.marketLocal"
              resize="none"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="游戏本地化：" prop="gameLocal">
            <el-input
              class="input-area small-area"
              type="textarea"
              :rows="3"
              placeholder="请输入"
              v-model="formData.gameLocal"
              resize="none"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="渠道/主要渠道：" prop="chnl">
            <channel-select width="700px" v-model="formData.chnl"></channel-select>
          </el-form-item>
          <el-form-item label="素材迭代组数：" prop="resourceNum">
            <el-input v-model="formData.resourceNum" placeholder="请输入" type="number"></el-input>
          </el-form-item>
          <el-form-item label="产品方向：" prop="productDirection">
            <WangEditor :isFullScreen="false" :value.sync="formData.productDirection"></WangEditor>
          </el-form-item>
          <el-form-item label="回收分析：" prop="recoveryAnalysis">
            <WangEditor :isFullScreen="false" :value.sync="formData.recoveryAnalysis"></WangEditor>
          </el-form-item>
          <el-form-item label="渠道/地区确认：" prop="chnlRegion">
            <WangEditor :isFullScreen="false" :value.sync="formData.chnlRegion"></WangEditor>
          </el-form-item>
          <el-form-item label="调整备注：" prop="adjustmentRemarks">
            <WangEditor :isFullScreen="false" :value.sync="formData.adjustmentRemarks"></WangEditor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="loading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPrincipalName, addProductLog } from "@/api/popuManage.js";
import ChannelSelect from "./channelSelect.vue";
import WangEditor from "@/components/wangEditor";
import moment from "moment";
export default {
  name: "EditModal",
  props: {
    productList: Array,
  },
  components: {
    ChannelSelect,
    WangEditor,
  },
  data() {
    return {
      dialogVisible: false,
      editId: null,
      formData: {
        productId: "",
        type: "",
        productStatus: "",
        principalName: [],
        market: "",
        productGrade: "",
        marketLocal: "",
        gameLocal: "",
        chnl: [],
        resourceNum: "",
        productDirection: "",
        recoveryAnalysis: "",
        chnlRegion: "",
        adjustmentRemarks: "",
      },
      principalNameList: [],
      loading: false,
      rules: {
        productId: [
          {
            required: true,
            message: "请选择产品",
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["blur", "change"],
          },
        ],
        // productStatus: [
        //   {
        //     required: true,
        //     message: "请选择投放状态",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // principalName: [
        //   {
        //     required: true,
        //     message: "请选择投放负责人",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // market: [
        //   {
        //     required: true,
        //     message: "请选择市场",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // productGrade: [
        //   {
        //     required: true,
        //     message: "请选择产品分级",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // marketLocal: [
        //   {
        //     required: true,
        //     message: "请输入市场本地化",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // gameLocal: [
        //   {
        //     required: true,
        //     message: "请输入游戏本地化",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // chnl: [
        //   {
        //     required: true,
        //     message: "请选择渠道/主要渠道",
        //     trigger: ["blur"],
        //   },
        // ],
        // resourceNum: [
        //   {
        //     required: true,
        //     trigger: ["blur", "change"],
        //     validator: (rule, value, callback) => {
        //       if (value === null || value === "") {
        //         callback(new Error("素材迭代组数必填"));
        //       } else if (parseInt(value) <= 0) {
        //         callback(new Error("素材迭代组数不规范"));
        //       } else {
        //         callback();
        //       }
        //     },
        //   },
        // ],
        // productDirection: [
        //   {
        //     required: true,
        //     message: "请输入产品方向",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // recoveryAnalysis: [
        //   {
        //     required: true,
        //     message: "请输入回收分析",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // chnlRegion: [
        //   {
        //     required: true,
        //     message: "请输入渠道/地区确认",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // adjustmentRemarks: [
        //   {
        //     required: true,
        //     message: "请输入调整备注",
        //     trigger: ["blur", "change"],
        //   },
        // ],
      },
    };
  },
  methods: {
    initSelect() {
      //投放负责人
      getPrincipalName().then((res) => {
        if (res.code === "0000") {
          this.principalNameList = res.list;
        }
      });
    },
    addData() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formWrapRef.scrollTop = 0;
      });
    },
    modalClosed() {
      this.$refs.tableRef.resetFields();
    },
    saveData() {
      this.$refs.tableRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          let copyData = JSON.parse(JSON.stringify(this.formData));
          copyData.chnl = JSON.stringify(copyData.chnl);
          copyData.principalName = copyData.principalName.join();
          //当前周日期范围
          let day = moment().day();
          let weekArr = [
            moment()
              .subtract(day - 1, "days")
              .format("YYYYMMDD"),
            moment()
              .subtract(day - 7, "days")
              .format("YYYYMMDD"),
          ];
          copyData.weeks = weekArr.join("-");

          addProductLog(copyData).then((res) => {
            this.loading = false;
            if (res.code === "0000") {
              this.$message({
                message: "产品新增成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.$emit("refresh", false);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  .form-wrap {
    height: 642px;
    overflow: auto;
    padding-right: 6px;
    /deep/ .el-form-item__label {
      padding: 0 4px 0 0;
    }
    /deep/ .el-input__inner {
      padding: 0px 0px 0px 15px;
    }
    /deep/ .el-form-item {
      &.is-required {
        .el-form-item__label::before {
          content: "*";
          display: inline-block;
          color: red;
        }
      }
    }
    /deep/ .w-e-text-placeholder {
      top: 5px;
    }
    .select-item {
      width: 100%;
    }
    .input-area {
      /deep/ .el-textarea__inner {
        height: 104px;
      }
      &.small-area {
        /deep/ .el-textarea__inner {
          height: 60px;
        }
      }
    }
  }
  .form-wrap::-webkit-scrollbar {
    width: 4px;
  }
  .form-wrap::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }
}
</style>
